<script setup lang="ts">
import {computed, ref} from 'vue'
import {useTheme} from 'vuetify';
import PoweredByOnlineImage from './assets/PoweredByOnlineImage.svg'
import UserAvatar from './components/UserAvatar.vue';
import BrandedLogo from './components/BrandedLogo.vue';
import OpenIdConfigurationDialog from './components/OpenIdConfigurationDialog.vue';
import {inject} from "vue";
import {PortalAuthKey} from "./plugins/auth.ts";
import User from "./models/User.ts";
import {LOGO_DARK, LOGO_LIGHT, THEME_NAMES} from "./vueify";
import GenAuthLogo_LightMode from './assets/GenAuthBranding/Logo-type-dark.svg'
import GenAuthLogo_DarkMode from './assets/GenAuthBranding/Logo-type-light.svg'

const auth = inject(PortalAuthKey);

const user = ref<User>(auth.authState.user);

const theme = useTheme()
const drawer = ref<boolean>()

const toggleTheme = (): void => {
  theme.global.name.value = theme.global.current.value.dark
      ? THEME_NAMES.ADMIN_LIGHT
      : THEME_NAMES.ADMIN_DARK
}

const themeToggleIcon = computed(() => (
    theme.global.current.value.dark ? 'mdi-weather-sunny' : 'mdi-weather-night'
));

const themeToggleLabel = computed(() => (
    theme.global.current.value.dark ? 'Switch to light mode' : 'Switch to dark mode'
));
</script>

<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer">
      <!-- <v-navigation-drawer theme="dark" v-model="drawer" :image="theme.global.name.value === 'darkTheme' ? DarkBgVert : LightBgVert"> -->
      <template v-slot:prepend>
        <v-list>
          <v-list-item class="mb-1">
            <div>
              <img v-if="theme.global.current.value.dark" :src="GenAuthLogo_DarkMode" class="w-100" />
              <img v-else :src="GenAuthLogo_LightMode" class="w-100" />
            </div>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list nav>
          <v-list-item to="/landing" prepend-icon="mdi-arrow-left" title="Back to Landing"></v-list-item>
        </v-list>
        <v-divider></v-divider>

      </template>
      <v-list nav>
        <v-list-item to="/admin/dashboard" prepend-icon="mdi-view-dashboard" title="Dashboard"></v-list-item>
        <v-list-item to="/admin/sessions" prepend-icon="mdi-monitor-multiple" title="Sessions"></v-list-item>
        <v-list-item to="/admin/apps" prepend-icon="mdi-application" title="Applications"></v-list-item>
<!--        <v-list-item to="/admin/urls" prepend-icon="mdi-web" title="Callback URLs"></v-list-item>-->
<!--        <v-list-item to="/admin/partners" prepend-icon="mdi-handshake" title="Partners"></v-list-item>-->
        <v-list-item to="/admin/users" prepend-icon="mdi-account" title="Users"></v-list-item>
<!--        <v-list-item to="/admin/permissions" prepend-icon="mdi-lock" title="Access Control"></v-list-item>-->
        <v-list-item to="/admin/whitelabel" prepend-icon="mdi-tag" title="Whitelabel Config"></v-list-item>
        <v-list-item to="/admin/reports" prepend-icon="mdi-file-document-multiple" title="Reports"></v-list-item>
        <v-list-item to="/admin/api-access" prepend-icon="mdi-api" title="API Access"></v-list-item>
        <v-list-item to="/admin/settings" prepend-icon="mdi-cog" title="Settings"></v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list density="compact">
          <v-list-item>
            <v-img :src="PoweredByOnlineImage"/>
          </v-list-item>
        </v-list>

      </template>
    </v-navigation-drawer>

    <v-app-bar>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <template v-slot:append>
        <OpenIdConfigurationDialog />
        <v-btn
            :icon="themeToggleIcon"
            :aria-label="themeToggleLabel"
            :title="themeToggleLabel"
            @click="toggleTheme"
        />
        <v-list density="compact" nav>
          <v-menu>
            <template v-slot:activator="{ props }">

              <v-btn icon variant="text" v-bind="props">
                <!-- <v-icon>mdi-account-circle</v-icon> -->
                <UserAvatar :user="user as User"></UserAvatar>
                <!-- <v-avatar v-if="userStore.data.user_icon" :image="userStore.getAvatar"></v-avatar>
                <v-avatar v-else :image="userStore.getAvatar"></v-avatar> -->
              </v-btn>
            </template>

            <v-list density="compact" nav>
              <v-list-item :title="user.first_name + ' ' + user.last_name"
                           :subtitle="user.email"></v-list-item>
              <v-divider></v-divider>
              <v-list-item to="/account" prepend-icon="mdi-account" title="My Account"></v-list-item>
              <v-list-item @click="auth.logout()" prepend-icon="mdi-logout"
                           title="Log Out"></v-list-item>
            </v-list>
          </v-menu>
        </v-list>
        <!-- <v-btn prepend-icon="mdi-logout">Log Out</v-btn> -->
      </template>
    </v-app-bar>

    <v-main>
      <v-defaults-provider :defaults="{ VToolbar: { color: 'admin_toolbar' } }">
        <v-container>
          <RouterView/>
        </v-container>
      </v-defaults-provider>
    </v-main>
  </v-app>
</template>
